import React from "react";
import { object } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { LazyLoadImages, LazyCollection } from "@quintype/components";

import SmallStoryCardWithTopBorder from "../molecules/smallStoryCardWithTopBorder";
import { getStoryFromCollection } from "../../helper/utils";
import Breadcrumb from "../molecules/breadcrumb";
import { More } from "../atoms/load-more-btn/index";
import { getCollectionTemplate } from "../get-collection-template";

import "./section.m.css";

const template = stories => {
  return (
    <>
      {stories.map(story => (
        <SmallStoryCardWithTopBorder story={story} key={story.id} />
      ))}
    </>
  );
};

const SectionPageBase = ({ data = {}, publisherAttributes }) => {
  const stories = getStoryFromCollection(data.collection);
  const { host_url: hostUrl, url_to_be_replaced: urlToBeReplaced } = publisherAttributes;

  const sectionName = data.section ? data.section["display-name"] || data.section.name : data.collection.name;

  const getSlug = () => {
    if (data.section) {
      const sectionUrl = data.section["section-url"].replace(urlToBeReplaced, hostUrl);
      return `${sectionUrl}?page=${data.pageNumber ? parseInt(data.pageNumber) + 1 : 2}`;
    }

    return `${hostUrl}/collection/${data.collection.slug}?page=${data.pageNumber ? parseInt(data.pageNumber) + 1 : 2}`;
  };

  if (!data.collection.items.length) {
    return null;
  }

  const getTemplate = () => {
    if (stories.length > 0) {
      return (
        <div>
          {template(stories.slice(0, 10))}
          {stories.length > 10 && (
            <a styleName="button-container" href={getSlug()}>
              <More text="আরও" />
            </a>
          )}
        </div>
      );
    }

    return (
      <LazyLoadImages>
        <LazyCollection collection={data.collection} collectionTemplates={getCollectionTemplate} lazyAfter={2} />
      </LazyLoadImages>
    );
  };

  return (
    <div>
      <Breadcrumb name={sectionName} />
      {getTemplate()}
    </div>
  );
};

SectionPageBase.propTypes = { data: object };

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export const SectionPage = connect(mapStateToProps)(SectionPageBase);
